import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_CORGI_SSR_CACHE_BUSTER = createFcmDetails('corgi_ssr_cache_buster', {
	owner: 'FE framework squad',
	context: 'corgi SSR',
	description: `Used to cache-bust the SSR server cache.
			Can be used when an issue with caching is discovered, and a quick fix is needed until a new release of corgi.
			Value can be anything, it just needs to be different that the previous one`,
	template: 1,
	import: false,
});
